// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//       navigator.serviceWorker.register('service-worker.js')
//           .then((registration) => {
//               console.log('Service Worker registered with scope:', registration.scope);
//           })
//           .catch((error) => {
//               console.error('Service Worker registration failed:', error);
//           });
//   });
// }
import { checkIfInPWA, isInPWA, isProtocolHandlerSupported } from '@/env'
import { CUSTOM_PROTOCOL } from '@/consts'

export enum Status {
  NOT_STARTED = -1,
  START_CHECK = 0,
  CHECK_SUCCESS = 1,
  CHECK_FAILED = 2,
  USER_ACCEPTED = 3,
  USER_DISMISSED = 4,
  INSTALL_SUCCESS = 5
}

const readyToInstall = ref(false)
const userAccepted = ref(false)
const status = ref<Status>(Status.NOT_STARTED)
// const customProtocol = "web+" + location.hostname.replace(/[^a-z]/g, "")

const promptEvent = ref<any>(null)
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  promptEvent.value = e;
  readyToInstall.value = true
  status.value = Status.CHECK_SUCCESS
});

const showInstallPrompt = async () => {
  await promptEvent.value.prompt();

  const choiceResult = await promptEvent.value.userChoice;
  if (choiceResult.outcome === 'accepted') {
    userAccepted.value = true
    localStorage.setItem('pwaInstalled', '1'); // 1 表示用户已接受安装，但可能安装失败
    console.log('User accepted the install prompt');
    return true
  } else {
    userAccepted.value = false
    console.log('User dismissed the install prompt');
    return false
  }
}

const installPWA = async () => {
  if (readyToInstall.value) {
    const result = await showInstallPrompt()
    if (result) {
      status.value = Status.USER_ACCEPTED
      
      setTimeout(() => {
        if (!isInPWA && checkIfInPWA()) location.reload()
      }, 2000)
    } else {
      status.value = Status.USER_DISMISSED
    }
  } else {
    showToast('Ambiente não está pronto, falha na instalação')
  }
}

const launchPWA = (protocol = CUSTOM_PROTOCOL, url = location.origin, queryString = '') => {
  let launchUrl = ''
  if (isProtocolHandlerSupported) {
    launchUrl = `${protocol}://${queryString}`;
  } else {
    launchUrl = `${url}?pwaredirect=${queryString}`;
  }
  location.href = launchUrl
}

export default function usePWA() {
  return {
    status,
    promptEvent,
    readyToInstall,
    userAccepted,
    showInstallPrompt,
    launchPWA,
    installPWA
  }
}
